import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'affected-systems',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'affected-systems-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.affected-systems-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "affected-systems-index" */ '@/modules/configurations/catalogs/affected-systems/views/Index.vue')
        },
        {
            path: 'create',
            name: 'affected-systems-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'affected-systems-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.affected-systems-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.affected-systems-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "affected-systems-create" */ '@/modules/configurations/catalogs/affected-systems/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'affected-systems-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'affected-systems-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.affected-systems-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.affected-systems-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "affected-systems-edit" */ '@/modules/configurations/catalogs/affected-systems/views/Edit.vue')
        }
    ]
}